import { render, staticRenderFns } from "./NIHSS.vue?vue&type=template&id=3748d9ea&"
import script from "./NIHSS.vue?vue&type=script&lang=ts&"
export * from "./NIHSS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3748d9ea')) {
      api.createRecord('3748d9ea', component.options)
    } else {
      api.reload('3748d9ea', component.options)
    }
    module.hot.accept("./NIHSS.vue?vue&type=template&id=3748d9ea&", function () {
      api.rerender('3748d9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/NIHSS.vue"
export default component.exports